module.exports = __webpack_public_path__ + "img/a5.047c012b.svg";